import {checkAccountGo, isUserPermitted} from '../api/go';
import {readLocalStorage, writeLocalStorage} from '../context/storageService';

/**
 * Replace strange characters like á
 * @param text String to normalize
 */
export const normalizeText = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const listenForAjax = (ajaxUrl, cb) => {
  const origOpen = XMLHttpRequest.prototype.open;
  // eslint-disable-next-line func-names
  XMLHttpRequest.prototype.open = function (
    method,
    url,
    async,
    user,
    password
  ) {
    this.addEventListener('load', () => {
      if (url.includes(ajaxUrl)) {
        cb();
      }
    });
    // eslint-disable-next-line prefer-rest-params
    origOpen.apply(this, arguments);
  };
};

export const isUserWithDecathlonGoActive = () => {
  if (!isUserPermitted(window.tc_vars.user_id_1id)) return false;
  let infoDecathlonGo;
  if (window.tc_vars.user_status === 'authenticated') {
    infoDecathlonGo = readLocalStorage('decathlon-go');
    if(!infoDecathlonGo || refreshInfo(infoDecathlonGo.lastSync)) {
      infoDecathlonGo = checkAccountGo(window.tc_vars.user_id_1id);
    }
    if(!infoDecathlonGo) return false;
    infoDecathlonGo.lastSync = new Date().getTime();
    writeLocalStorage('decathlon-go', infoDecathlonGo);
  }
  const subscriptionEnd = new Date(infoDecathlonGo.subscriptionEnd);
  const now = new Date();
  return subscriptionEnd > now;
};

const refreshInfo = ( lastSync ) => {
  const dateTime = new Date().getTime();
  return ( dateTime > lastSync * 1000 * 60 * 60);
};



// WEBPACK FOOTER //
// ./src/_override/common/utils.js